import React from 'react';
import PropTypes from 'prop-types';
import "./rscard.css"

const RsCardImgv3 = ({ title, description, iconClass }) => {
  return (
  <div className="card rs-card bg-v2 rs-card-compact">
  <div className="card-body py-2 px-3">
    <div className="d-flex align-items-center justify-content-between">
      
      <div className="lead-number">
        <h2 className="mb-0 fw-bold text-dark">{description}</h2>
      </div>

     
      <div className="text-end d-flex flex-column align-items-center">
        <img src={iconClass} width={36} alt="icon" className="mb-1" />
        <h6 className="mb-0 text-muted font-size-17">{title}</h6>
      </div>

    </div>
  </div>
</div>

  );
};

RsCardImgv3.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  iconClass: PropTypes.string,
};

RsCardImgv3.defaultProps = {
  title: 'Default Title',
  description: 'Default Description',
  iconClass: 'bx-default-icon',
};

export default RsCardImgv3;